var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-card', {
    staticClass: "shadow-sm p-2 p-md-2",
    staticStyle: {
      "border-radius": "12px"
    }
  }, [_c('div', {
    staticClass: "text-center text-md-left"
  }, [_c('h3', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Income Tax Calculation")]), _c('p', {
    staticClass: "mb-0",
    staticStyle: {
      "font-size": "0.95rem",
      "line-height": "1.5"
    }
  }, [_vm._v(" Please upload a "), _c('strong', [_vm._v("PDF document (max 10 pages)")]), _vm._v(" containing your applicable tax rules. Ensure it follows the required guidelines below for accurate AI processing. ")])]), _c('div', {
    staticClass: "instructions-scroll-wrapper mt-4"
  }, [_c('div', {
    staticClass: "instructions-container bg-light p-3 rounded"
  }, [_c('h5', {
    staticClass: "font-weight-bold mb-2"
  }, [_vm._v("Instructions")]), _c('p', {
    staticClass: "mb-1",
    staticStyle: {
      "line-height": "1.5"
    }
  }, [_vm._v(" Please upload a PDF document containing your applicable tax rules. To ensure accurate processing by our AI, follow these requirements: ")]), _c('ul', {
    staticClass: "pl-3 mb-1",
    staticStyle: {
      "line-height": "1.6"
    }
  }, [_c('li', [_c('strong', [_vm._v("Language:")]), _vm._v(" The document must be written in English.")]), _c('li', [_c('strong', [_vm._v("Length:")]), _vm._v(" Maximum of 10 pages.")]), _c('li', [_c('strong', [_vm._v("Content to Include:")])]), _c('ul', {
    staticClass: "pl-3"
  }, [_c('li', [_vm._v("Clear description of tax categories (e.g., VAT, sales tax, service tax).")]), _c('li', [_vm._v("Applicable rates or percentages for each category.")]), _c('li', [_vm._v("Conditions or thresholds (e.g., exemptions, minimum/maximum amounts, region-specific rules).")]), _c('li', [_vm._v("Any formulas or calculation methods if applicable.")]), _c('li', [_vm._v("Effective dates of the rules (if time-based).")]), _c('li', [_vm._v("References to jurisdictions or regions where rules apply.")])])]), _c('p', {
    staticClass: "mb-1",
    staticStyle: {
      "line-height": "1.5"
    }
  }, [_vm._v(" Make sure the document is organized, concise, and free of unnecessary information, so AI can read and apply the rules correctly. ")]), _c('p', {
    staticClass: "text-danger font-weight-bold mb-0"
  }, [_vm._v(" Note: If your tax regulations change, you must upload a new version of the PDF. ")])])]), _c('validation-observer', {
    ref: "incomeTaxPolicyValidation"
  }, [_c('b-form', {
    staticClass: "mt-4",
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.validationForm($event);
      }
    }
  }, [_c('b-row', {
    staticClass: "d-flex justify-content-center align-content-center flex-wrap"
  }, [_c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "cols": "12",
      "md": "6",
      "lg": "4"
    }
  }, [_c('b-form-group', {
    staticClass: "required-label mb-2",
    attrs: {
      "label": "",
      "label-for": "title"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "Income Tax Calculation",
      "rules": "size:2048|ext:jpeg,png,jpg,pdf,doc",
      "vid": "document"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors;
        return [_c('b-form-file', {
          staticClass: "rounded",
          attrs: {
            "id": "document",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Choose a file or drop it here...",
            "drop-placeholder": "Drop file here...",
            "browse-text": "Browse File"
          },
          model: {
            value: _vm.document,
            callback: function callback($$v) {
              _vm.document = $$v;
            },
            expression: "document"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    staticClass: "d-flex align-items-start justify-content-center mt-2 mt-md-0",
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_vm.isIncomeTaxPolicyFormSubmitLoading ? [_c('b-button', {
    staticClass: "float-right",
    attrs: {
      "variant": "primary",
      "disabled": "",
      "block": ""
    }
  }, [_c('b-spinner', {
    staticClass: "mr-50",
    attrs: {
      "small": ""
    }
  }), _vm._v(" Loading... ")], 1)] : [_c('b-button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple.400",
      value: 'rgba(255, 255, 255, 0.15)',
      expression: "'rgba(255, 255, 255, 0.15)'",
      modifiers: {
        "400": true
      }
    }],
    staticClass: "float-right",
    staticStyle: {
      "min-width": "120px"
    },
    attrs: {
      "type": "submit",
      "block": "",
      "variant": "primary"
    }
  }, [_vm._v(" Submit ")])]], 2)], 1)], 1)], 1), _c('hr', {
    staticClass: "my-4"
  }), _c('div', {
    staticClass: "text-center mt-3"
  }, [_c('b-button', {
    staticClass: "d-inline-flex align-items-center px-4 py-2",
    staticStyle: {
      "border-radius": "8px",
      "font-weight": "500"
    },
    attrs: {
      "variant": "warning"
    },
    on: {
      "click": _vm.download
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "DownloadIcon"
    }
  }), _vm._v(" Download ")], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }